// extracted by css-extract-rspack-plugin
export default {"readMore":"read-more--JPPVDq1CXDcsYbqe","list":"list--dRgsCTttnEEUbZTk","itemContainer":"item-container--Nt9GFNSxJU0MBZyT"};